import Vue from 'vue';
import moment from 'moment';

Vue.mixin({
  methods: {
    moment(date, type) {
      if (type) {
        return moment(date).format(type);
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    momentutc(data, type) {
      if (type) {
        return moment(data).utc().format(type);
      }
      return moment(data).utc().format('YYYY-MM-DD HH:mm:ss');
    }
  },
});
